const React = require("react");

const useId = require('@reach/auto-id').useId;

function CloseOutlinedIcon(props, svgRef) {
  const id = "CloseOutlinedIcon" + '_' + useId();
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.19 5.649a.5.5 0 01-.006.707l-5.555 5.477 5.555 5.478a.5.5 0 01.063.637l-.058.07a.5.5 0 01-.707.005l-5.566-5.488-5.565 5.488a.5.5 0 01-.702-.712l5.555-5.478-5.555-5.477a.5.5 0 01-.062-.637l.057-.07a.5.5 0 01.707-.005l5.565 5.486 5.566-5.486a.5.5 0 01.707.005z",
    id: `${id}_a`
  })), /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: `#${id}_a`
  }));
}

const ForwardRef = React.forwardRef(CloseOutlinedIcon);
const MemoForwardRef = React.memo(ForwardRef);
module.exports = MemoForwardRef;